//该配置文件是教室下拉框
//@author lst
import { component_tool } from '@/tool'
import {WizTableForm} from '@/containers/common'
const { WizLocationSelect } = component_tool

const columns=()=>{
    return [
        {
          name: 'id',
          formItem: {
            type: 'hidden'
          }
        },
        {
          title: '场地名称',
          name: 'name',
          searchItem: {},
          tableItem: {
            width: 220
          },
        },
        {
          title: '场地编号',
          name: 'code',
          searchItem: {},
          tableItem: {
            width: 220
          },
        },
        {
          title: '培训中心',
          name: 'trainCenterId',
          searchItem: {
            type: 'diy',
            selectType: 'radio',
            diy: WizTableForm,
          ...WizTableForm.Config.trainCenter()
          }
        },
        {
          title: '培训中心',
          name: 'trainCenterName',
          tableItem: {
            width: 220
          },
        },
        {
          title: '城市',
          name: 'city',
          dataIndex: 'city',
          searchItem: {
            type: 'diy',
            diy: WizLocationSelect,
            showSearch: true
          },
          tableItem: {
            width: 220
          },
        },
        {
          title: '场地地址',
          name: 'address',
          tableItem: {
            width: 220,
            maxLength: 100
          }
        }
      ]
}

const tableApi = (api = {}) => {
    return {
      path: 'trainSite/list',
      ...api
    }
}
const trainSite = (self, api) => {
    return {
      type: 'diy',
      initialValue: [],
      columns: columns(api),
      tableApi: tableApi(api),
      selectType: 'radio'
    }
  }
  
  export default trainSite